<!--客户回访记录-->
<template>
    <div class="order-infoTab-section" v-loading="loading">
        <div class="order-hd">
            <a href="javascript:;" @click="writeVisit" v-if="Acs('/customer/visits/create')" >+添加回访记录</a>
        </div>
        <div class="order-bd" >
            <el-steps direction="vertical">
                <el-step icon="el-icon-fa-user" v-for="(visit, index) in visits" :key="index" >
                    <div slot="title" class="title-step">
                        <span>{{visit.username}}</span>
                        <span>联系人：{{visit.contact_name}}</span>
                        <span>回访时间：{{visit.created_at}}</span>
                        <span v-if="visit.next_time">下次回访时间：{{visit.next_time}}</span>
                        <span>回访类型: {{visit.type_label}}</span>
                        <span>回访方式: {{visit.method_label}}</span>
                        <span>回访状态: {{visit.status_label}}</span>
                        <span>跟进产品: </span>
                        <span v-for="product in visit.products" :key="product.id" >{{product.product_name}}<span v-if="visit.products.length > 1" >、</span></span>
                    </div>
                    <div slot="description" class="des-step" >
                        <div>详细内容：{{visit.content}} </div>
                    </div>
                </el-step>
            </el-steps>
        </div>

        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
        </el-row>

        <!-- 回访组件 -->
        <visit-modal
                :show-dialog="showVisitModal"
                :customer-id="customerId"
                @closeModal="closeModal"
                @saveCallback="saveCallback"
        >
        </visit-modal>

    </div>
</template>

<script>
    import {VisitService} from "~/services/CustomerVisit";
    import Pagination from "~/widgets/Pagination.vue";
    import VisitModal from "~/views/tasks/VisitModal.vue";

    export default {
        name: "CustomerVisits",
        components: {
            Pagination,
            VisitModal
        },
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
        },
        watch : {
            customerId: function (value, original) {
                this.getVisits({customer_id: value});
            },
        },
        data() {
            return {
                visits: [],
                loading: true,
                // 分页信息
                linkPage: null,
                // 控制显示填写回访记录对话框
                showVisitModal: false,
            };
        },
        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function(to, from, next) {
            this.$route.query['page'] = to.query['page'];
            this.$route.query['perPage'] = to.query['perPage'];
            // this.getVisits({
            //     customer_id: this.customerId,
            //     page: to.query["page"],
            //     perPage: to.query["perPage"]
            // });
        },
        created: function() {
            if (this.visits.length < 1 && this.customerId > 0) {
                this.getVisits({customer_id: this.customerId});
            }
        },
        methods: {
            getVisits(params) {
                VisitService.getList(params).then(res => {
                    if (res && res.data) {
                        this.visits = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    console.error(err);
                })
            },

            watchPageChange(pageParams) {
                this.getVisits({
                    customer_id: this.customerId,
                    page: pageParams["page"],
                    perPage: pageParams["perPage"]
                });
            },

            // 监听对话框关闭事件
            closeModal(isShow) {
                this.showVisitModal = isShow;
            },

            // 填写跟进
            writeVisit() {
                // 显示跟进表单对话框
                this.showVisitModal = true;
                this.getVisits({customer_id: this.customerId})
            },

            // 跟进记录提交保存后触发的回调
            saveCallback() {
                // 重新加载跟进列表
                this.getVisits({customer_id: this.customerId})
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/views/customer/Visits.vue